import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const SITE_URL = 'https://loanyardcapital.com';

export const CalcBreadcrumb = ({ name, path }) => {
  useEffect(() => {
    if (document.getElementById('calc-breadcrumb-schema')) return;
    const schema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: `${SITE_URL}/` },
        { '@type': 'ListItem', position: 2, name, item: `${SITE_URL}${path}` }
      ]
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'calc-breadcrumb-schema';
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => {
      const el = document.getElementById('calc-breadcrumb-schema');
      if (el) el.remove();
    };
  }, [name, path]);

  return (
    <nav aria-label="Breadcrumb" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 mb-4" data-testid="calc-breadcrumb">
      <Link to="/" className="hover:text-emerald-600 transition-colors">Home</Link>
      <ChevronRight className="w-3.5 h-3.5 text-slate-400" />
      <span className="text-slate-700 font-medium">{name}</span>
    </nav>
  );
};

export const CalcRelatedLinks = ({ links }) => (
  <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 mt-4 text-sm" data-testid="calc-related-links">
    <span className="text-slate-500">Related solutions:</span>
    {links.map(([label, to], i) => (
      <React.Fragment key={to}>
        {i > 0 && <span className="text-slate-300">·</span>}
        <Link to={to} className="text-emerald-700 font-semibold hover:text-emerald-600 transition-colors">{label}</Link>
      </React.Fragment>
    ))}
  </div>
);
